
















































































































































import { Component, Vue } from 'vue-property-decorator';
import api, {Content, SearchResult} from '@/api';
import AdComponent from '@/components/AdComponent.vue';

export interface SearchResultWithCheck {
    searchResult: Content;
    isChecked: boolean;
}

@Component({
    components: {
        ad: AdComponent,
    },
})
export default class BookAddView extends Vue {
    private validTitleSearchBox: boolean = true;
    private validAuthorSearchBox: boolean = true;
    private inputTitleForSearch: string = '';
    private inputAuthorForSearch: string = '';
    private isSearchLoading: boolean = false;
    private searchResultWithCheck: SearchResultWithCheck[] = [];
    private page: number = 1;
    private perPage: number = 18;
    private totalCount: number = 1;
    private alert: boolean = false;
    private message = '';
    private isSearchAfter: boolean = false;

    private mounted() {
        window.scrollTo(0, 0);
    }

    private searchBook() {
        this.isSearchLoading = true;
        this.alert = false;
        let inputAuthor: string | null = null;
        if (this.inputAuthorForSearch.length === 0) {
            inputAuthor = null;
        } else {
            inputAuthor = this.inputAuthorForSearch;
        }
        let inputTitle: string | null = null;
        if (this.inputTitleForSearch.length === 0) {
            inputTitle = null;
        } else {
            inputTitle = this.inputTitleForSearch;
        }

        api.rakuten.search(this.page, this.perPage, inputTitle, inputAuthor, null, null, null)
            .then((res) => {
                const searchResult = res.data as SearchResult;
                this.totalCount = searchResult.pageCount;
                this.searchResultWithCheck = searchResult.Items.map((x) => {
                    return {
                        searchResult: x.Item,
                        isChecked: false,
                    } as SearchResultWithCheck;
                });
                this.scrollResult();
            })
            .catch((err) => {
                // console.log(err);
                this.alert = true;
                this.message = '検索エラーです。もう一度お試しください。';
            })
            .finally(() => {
                this.isSearchLoading = false;
                this.isSearchAfter = true;
            });
    }

    get getSearchResult() {
        return this.searchResultWithCheck;
    }

    private addBook(book: Content) {
        this.$store.dispatch('setBook', book)
            .then((r) => {
                // console.log(res);
                this.$router.push({name: 'register'});
            }).catch((err) => {
                this.alert = true;
                this.message = '登録エラーです。もう一度お試しください。';
        });
    }

    private pagenaite() {
        this.scrollResult();
        this.searchBook();
    }

    private reshapeString(st: string, len: number): string {
        if (st.length > len) {
            return st.slice(0, len) + '....';
        } else {
            return st;
        }
    }

    private scrollResult() {
        const q = document.getElementById('search_button');
        if (q != null) {
            q.scrollIntoView();
        }
    }

}

